export default {"src":"/_next/static/media/professional_research_training_program.a695ee77.svg","height":595,"width":842};